"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getSanitizedContentTitle = require("./getSanitizedContentTitle");
Object.keys(_getSanitizedContentTitle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getSanitizedContentTitle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getSanitizedContentTitle[key];
    }
  });
});